import * as React from 'react';

import { netLabel } from './messages.tsx';

// Component
import { PriceLabel } from './PriceLabel.tsx';
import { textPercentageOff } from '../helpers/priceTypeConstants.tsx';

// Styles
import styles from './styles.scss';

type NetProps = {
    currency: string;
    percentageOff?: string | null;
    price: number;
    quantityDisplay?: string | null;
    showPriceVariability?: boolean | null;
};

export const Net: React.FC<NetProps> = ({
    percentageOff = null,
    price,
    quantityDisplay,
    currency,
    showPriceVariability = false,
}) => {
    return (
        <React.Fragment>
            <PriceLabel
                price={price}
                label={netLabel}
                quantityDisplay={quantityDisplay}
                currency={currency}
                showPriceVariability={showPriceVariability}
            />
            {percentageOff ? (
                <div className={`${styles.percentageOff} ${styles.net}`} data-tn="discount-amount">
                    {textPercentageOff(percentageOff)}
                </div>
            ) : null}
        </React.Fragment>
    );
};
